import React from 'react'
import { connect } from 'react-redux'
import {showBackToSchoolModal} from '../actions/backToSchoolModal'
import {getUserSegment} from '../utils/getUserSegment'


//Logic

// ActiveMonthly and ChurnedPro see back to school modal
//Users with no history see 'Getting Started'

//Users on free plan who are not shown 'Getting Started' see 'Upgrade'

 


 const googleFormLink="https://forms.gle/w1M8ufzMnsYz91G2A" 
 const betaSignupFormLink="https://forms.gle/oxQ5cdGMARrUo9tP6"

class ContextBadge extends React.Component{


	constructor(){
		super()		
		this.shouldDisplayUpgradeButton=this.shouldDisplayUpgradeButton.bind(this)
		this.buttonToDisplay=this.buttonToDisplay.bind(this)
		this.shouldDisplayGettingStartedButton=this.shouldDisplayGettingStartedButton.bind(this)
		this.shouldDisplayUpgradeButton=this.shouldDisplayUpgradeButton.bind(this)
		this.shouldDisplayBackToSchoolButton=this.shouldDisplayBackToSchoolButton.bind(this)
		this.showBackToSchoolModal=this.showBackToSchoolModal.bind(this)
		this.showGoogleForm=this.showGoogleForm.bind(this)
		this.showDiscoverBetaBadge=this.showDiscoverBetaBadge.bind(this)
		this.showNewCreatorFundBadge=this.showNewCreatorFundBadge.bind(this)

		let isDiscountPeriod=false
		const discountPeriodStartDate = process.env.REACT_APP_DEFAULT_COUPON_START_DATE
		const discountPeriodEndDate = process.env.REACT_APP_DEFAULT_COUPON_END_DATE
		const currentDate = new Date()
		const startDate = new Date(discountPeriodStartDate)
		const endDate = new Date(discountPeriodEndDate)

		if(startDate<currentDate && endDate > currentDate){
		   isDiscountPeriod=true
		} 

		this.state={
			isDiscountPeriod:isDiscountPeriod
		}

	}


	showUpgrade(){
		window.location.hash='upgrade'
		if(window.analytics){
			window.analytics.track('Context Menu Badge Click',{
				type:'defaultUpgrade'
			})
		}
	}

	showGettingStartedGuide(){
		const win = window.open('https://help.plickers.com/hc/en-us/articles/360008947934-Getting-Started-Guide', '_blank')
  		win.focus()
		if(window.analytics){
			window.analytics.track('Context Menu Badge Click',{
				type:'gettingStartedGuide'
			})
		}
	}

	showCreatorFundAnnouncement(){
		const win = window.open('https://www.plickerscreatorfund.com/', '_blank')
  		win.focus()
		if(window.analytics){
			window.analytics.track('Context Menu Badge Click',{
				type:'creatorFundAnnouncement'
			})
		}
	}


	showCreatorFundGoogleForm(){
		const win = window.open('https://forms.gle/GBmcJmbqPQXPQXXEA', '_blank')
  		win.focus()
		if(window.analytics){
			window.analytics.track('Context Menu Badge Click',{
				type:'newCreatorFundForm'
			})
		}
	}

	showDiscoverBetaModal(){
		window.location.hash='discover-beta'
		if(window.analytics){
			window.analytics.track('Context Menu Badge Click',{
				type:'discoverBeta'
			})
		}
	}

	showELearningBetaModal(){
		window.location.hash='discover-beta'
		if(window.analytics){
			window.analytics.track('Context Menu Badge Click',{
				type:'eLearningBeta'
			})
		}
	}




	showGoogleForm(){
		const win = window.open(googleFormLink, '_blank')
  		win.focus()
		if(window.analytics){
			window.analytics.track('Context Menu Badge Click',{
				type:'covidForm'
			})
		}
	}

	showBetaSignupForm(){
		const win = window.open(betaSignupFormLink, '_blank')
  		win.focus()
		if(window.analytics){
			window.analytics.track('Context Menu Badge Click',{
				type:'betaSignupForm'
			})
		}
	}




	showCreatorFundBadge(){
		let showCreatorFundBadge=false
		const showBadgeEndDate = new Date('2020-03-31')
		const currentDate = new Date()
		if(currentDate<showBadgeEndDate){
			showCreatorFundBadge=true
		} 
		return showCreatorFundBadge
	}




	showNewCreatorFundBadge(){
		return false
	// 	const {meta}=this.props
	// 	const browserLanguage = window.navigator.userLanguage || window.navigator.language
	// 	if(browserLanguage==='en-US'){
	// 		if(meta && meta.discoveryBetaSurveyResponse && meta.discoveryBetaSurveyResponse.length>0 && meta.discoveryBetaSurveyResponse[0]!=='declineToAnswer' && meta.discoveryBetaSurveyResponse[0]!=='other'){
	// 		return true
	// 	}
	// 	else return false
	// }else return false
		
	}

	showDiscoverBetaBadge(){
		const {meta}=this.props
		if(meta && !meta.discoveryBetaOptedInAt && !meta.discoveryBetaOptedOutAt && meta.discoveryBetaSurveyResponse && meta.discoveryBetaSurveyResponse.length>0 && meta.discoveryBetaSurveyResponse[0]!=='declineToAnswer' && meta.discoveryBetaSurveyResponse[0]!=='other'){
			return true
		}
		else return false
	}




	showBackToSchoolModal(userSegment){
		this.props.showBackToSchoolModal(true)
		let type=''
		if(userSegment==='free'){
			type='BTS2019-Free'
		}else if(userSegment==='churnedPro'){
			type='BTS2019-ChurnedPro'
		}else if(userSegment==='activeMonthlyPro'){
			type='BTS2019-ActiveMonthlyPro'
		}else if(userSegment==='activeYearlyProNo2019Coupon'){
			type='BTS2019-ActiveYearlyPro'
		}
		
		if(window.analytics){
			window.analytics.track('Context Menu Badge Click',{
				type:type
			})
		}



	}




	shouldDisplayGettingStartedButton(){
		let shouldDisplay=true
		if(this.props.historySetPolls.length >0 || this.props.historyQuestionPolls.length>0){
			shouldDisplay=false
		}
		return shouldDisplay
	}


	shouldDisplayUpgradeButton(){
		return this.props.service.product==='free'
	}


	shouldDisplayBackToSchoolButton(){
		const {isDiscountPeriod}=this.state
		const {backToSchoolModal}=this.props
		if(!isDiscountPeriod){
			return false
		}else if(backToSchoolModal && backToSchoolModal.permenantlyDismissed){
			return false
		}else{
			const userSegment = getUserSegment()
			if(userSegment==='churnedPro' || userSegment==='activeMonthlyPro'){
				return true
			}
			else return false
		}

		
	}



	buttonToDisplay(){

		const showPaymentFailure = false
		const showGoogleFormBadge=false
		const showBetaSignupFormBadge=false
		const showBetaBadge=false

		let badgeType=null
		if(this.props.historySetPolls && this.props.historyQuestionPolls && this.props.meta && this.props.service){
			// if(this.shouldDisplayGettingStartedButton()){
			// 	badgeType='gettingStarted'
			// }


			if(this.showDiscoverBetaBadge()){
				badgeType='discoverBeta'
			}
			else if(this.showNewCreatorFundBadge()){
				badgeType='newCreatorFundForm'
			}

			else if(showBetaBadge){
				badgeType='syncBeta'
			}
			else if(showBetaSignupFormBadge){
				badgeType='betaSignupForm'
			}
		
			else if(showGoogleFormBadge){
				badgeType='googleForm'
			}

			else if(this.showCreatorFundBadge()){
				badgeType='creatorFund'
			}

			else if(this.shouldDisplayBackToSchoolButton()){
				badgeType='backToSchool'
			}

			
			else if(this.shouldDisplayUpgradeButton()){
				badgeType='upgrade'
			}else if(showPaymentFailure){
				badgeType='paymentFailure'
			}
		}
		return badgeType
	}





	render(){	
		const button=this.buttonToDisplay()
		const {isDiscountPeriod}=this.state
		const userSegment = getUserSegment()

		const fall2020DiscountContextBadgeLabel = 'Upgrade today for $4.79/month'



		if(button==='newCreatorFundForm'){
			return(		
				<div className='contextBadge contextBadge--creatorFundAnnounce' onClick={this.showCreatorFundGoogleForm}>				
					New Creator Fund
				</div>
			)
		}
		else if(button==='discoverBeta'){
			return(		
				<div className='contextBadge contextBadge--creatorFundAnnounce' onClick={this.showDiscoverBetaModal}>				
					Join Discover Beta
				</div>
			)
		}

		else if(button==='syncBeta'){
			return(		
				<div className='contextBadge contextBadge--creatorFundAnnounce' onClick={()=>{window.location.hash='beta-modal'}}>				
					e-Learning Tutorial
				</div>
			)
		}
		else if(button==='betaSignupForm'){
			return(		
				<div className='contextBadge contextBadge--creatorFundAnnounce' onClick={()=>{this.showBetaSignupForm()}}>				
					Try e-Learning
				</div>
			)
		}

		else if(button==='googleForm'){
			return(		
				<div className='contextBadge contextBadge--creatorFundAnnounce' onClick={()=>{this.showGoogleForm()}}>				
					School Closures Survey
				</div>
			)
		}
		else if(button==='creatorFund'){
			return(		
				<div className='contextBadge contextBadge--creatorFundAnnounce' onClick={()=>{this.showCreatorFundAnnouncement()}}>				
					March Creator Fund open
				</div>
			)
		}
		else if(button==='gettingStarted'){
			return(		
				<div className='contextBadge' onClick={()=>{this.showGettingStartedGuide()}}>
					Getting Started Guide
				</div>			
			)
		}else if(button==='upgrade'){
			return(		
				<div className='contextBadge' onClick={this.showUpgrade}>
					{isDiscountPeriod?`${fall2020DiscountContextBadgeLabel}`:'Upgrade to Pro'}
				</div>			
			)
		}
		else if(button==='paymentFailure'){
			return(		
				<div className='contextBadge contextBadge--error' onClick={this.showUpgrade}>
					Payment Problem
				</div>			
			)
		}

		else return null
	}
}


export default connect(
	(state) => ({
		meta:state.meta,
		historySetPolls:state.historySetPolls,
		historyQuestionPolls:state.historyQuestionPolls,
		service:state.service,
		backToSchoolModal:state.backToSchoolModal,

	
	}),
	{ showBackToSchoolModal}
)(ContextBadge)
